module.exports = __webpack_public_path__ + "img/icon-fail.1d711732.png";